// extracted by mini-css-extract-plugin
export default {"textHelper":"styles-module__textHelper__src-labstep-web-core-Text-Helper-_p4ybT"};